import React, { useEffect, useState } from 'react'
import "./reportModal.scss"
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { SocketState } from '../../../context/SocketProvider'
import { useDispatch, useSelector } from 'react-redux'
import { SET_MAIN_LOADER } from '../../../redux/loaderSlice'
import { AuthState } from '../../../context/AuthProvider'
import ModalContainer from '../../../2d-game/modals/ModalContainer'
import { selectPickReport } from '../../../redux/3d_game_Slice/gameinfo3d'
import AccountPrintPage from './AccountPrintPage'

function AccountPopup3d() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { socket } = SocketState()
  const lotteryReport = useSelector(selectPickReport)
  let { userDetail } = AuthState()
  console.log(userDetail)
  const [fromDate, setfromDate] = useState(moment().format('yyyy-MM-DD'))
  const [toDate, setToDate] = useState(moment().format('yyyy-MM-DD'))
  const [totalAmount, setTotalAmount] = useState([])
  const [reportType, setReportType] = useState('all') // default All selected

  useEffect(() => {
    submit()
  }, [])


  useEffect(() => {
    let finalData = { play_amount: 0, win_amount: 0, end_amount: 0, commission_amount: 0, final_amount: 0 }

    lotteryReport.forEach(element => {
      if (reportType === "3d" && element.games?.pick_three_game) {
        let g = element.games.pick_three_game
        finalData.play_amount += g.play_amount
        finalData.win_amount += g.win_amount
        finalData.end_amount += g.end_amount
        finalData.commission_amount += g.commission_amount
        finalData.final_amount += (g.play_amount - g.win_amount) - g.commission_amount
      }
      if (reportType === "2d" && element.games?.mini_lottery_game) {
        let g = element.games.mini_lottery_game
        finalData.play_amount += g.play_amount
        finalData.win_amount += g.win_amount
        finalData.end_amount += g.end_amount
        finalData.commission_amount += g.commission_amount
        finalData.final_amount += (g.play_amount - g.win_amount) - g.commission_amount
      }
      if (reportType === "lucky_sorat" && element.games?.lucky_sorat) {
        let g = element.games.lucky_sorat
        finalData.play_amount += g.play_amount
        finalData.win_amount += g.win_amount
        finalData.end_amount += g.end_amount
        finalData.commission_amount += g.commission_amount
        finalData.final_amount += (g.play_amount - g.win_amount) - g.commission_amount
      }

      if (reportType === "two_chance" && element.games?.two_chance) {
        let g = element.games.two_chance
        finalData.play_amount += g.play_amount
        finalData.win_amount += g.win_amount
        finalData.end_amount += g.end_amount
        finalData.commission_amount += g.commission_amount
        finalData.final_amount += (g.play_amount - g.win_amount) - g.commission_amount
      }
      if (reportType === "all") {
        if (element.games?.pick_three_game) {
          let g = element.games.pick_three_game
          finalData.play_amount += g.play_amount
          finalData.win_amount += g.win_amount
          finalData.end_amount += g.end_amount
          finalData.commission_amount += g.commission_amount
          finalData.final_amount += (g.play_amount - g.win_amount) - g.commission_amount
        }
        if (element.games?.mini_lottery_game) {
          let g = element.games.mini_lottery_game
          finalData.play_amount += g.play_amount
          finalData.win_amount += g.win_amount
          finalData.end_amount += g.end_amount
          finalData.commission_amount += g.commission_amount
          finalData.final_amount += (g.play_amount - g.win_amount) - g.commission_amount
        }
        if (element.games?.lucky_sorat) {
          let g = element.games.lucky_sorat
          finalData.play_amount += g.play_amount
          finalData.win_amount += g.win_amount
          finalData.end_amount += g.end_amount
          finalData.commission_amount += g.commission_amount
          finalData.final_amount += (g.play_amount - g.win_amount) - g.commission_amount
        }
        if (element.games?.two_chance) {
          let g = element.games.two_chance
          finalData.play_amount += g.play_amount
          finalData.win_amount += g.win_amount
          finalData.end_amount += g.end_amount
          finalData.commission_amount += g.commission_amount
          finalData.final_amount += (g.play_amount - g.win_amount) - g.commission_amount
        }
      }
    })

    setTotalAmount([...[finalData]])
  }, [lotteryReport, reportType])

  let submit = () => {
    dispatch(SET_MAIN_LOADER(true))

    let data = {
      "en": "PICK_THREE_REPORT",
      "data": {
        "start_date": moment(fromDate, 'yyyy-MM-DD').format('DD-MM-yyyy'),
        "end_date": moment(toDate, 'yyyy-MM-DD').format('DD-MM-yyyy')
      }
    }
    socket.emit('req', data)
    dispatch(SET_MAIN_LOADER(false))
  }

  // 🔹 Build records (with filtering + sorting)
  const buildRecords = () => {
    let allRecords = lotteryReport.flatMap((element) => {
      let rows = []
      if (reportType === "all" || reportType === "3d") {
        if (element.games?.pick_three_game) {
          rows.push({ ...element.games.pick_three_game, type: "3D" })
        }
      }
      if (reportType === "all" || reportType === "2d") {
        if (element.games?.mini_lottery_game) {
          rows.push({ ...element.games.mini_lottery_game, type: "4D" })
        }
      }
      if (reportType === "all" || reportType === "lucky_sorat") {
        if (element.games?.lucky_sorat) {
          rows.push({ ...element.games.lucky_sorat, type: "Titli" })
        }
      }
      if (reportType === "all" || reportType === "two_chance") {
        if (element.games?.two_chance) {
          rows.push({ ...element.games.two_chance, type: "2D" })
        }
      }
      return rows
    })
      .filter(gameData => {
        const d = moment(gameData.date, "DD:MM:YYYY")
        return d.isBetween(moment(fromDate), moment(toDate), 'day', '[]')
      })
      .sort((a, b) => moment(b.date, "DD:MM:YYYY") - moment(a.date, "DD:MM:YYYY"))

    return allRecords
  }

  return (
    <ModalContainer title={'Report'} navigation={localStorage.getItem('gameRoute') === "3d" ? '/3d' : localStorage.getItem('gameRoute') === "2d" ? '/2d' : localStorage.getItem('gameRoute') === "1d" ? '/1d' : '/titli'}>
      <div className="report_content">

        {userDetail?.is_user !== true && (

          <div className='w-1/4 px-4 self-center'>
            <button
              className="bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
              onClick={() => navigate("/createUser")}
            >
              Create
            </button>
          </div>
        )}
        {/* Date Filters */}
        <div className="date_search_section flex items-center">
          <div className='w-full flex'>
            {/* From Date */}
            <div className='w-1/4 px-4'>
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="from">From</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="from"
                  type="date"
                  value={fromDate}
                  onChange={(e) => setfromDate(e.target.value)}
                  max={moment().format('yyyy-MM-DD')}
                  min={'2023-04-1'}
                />
              </div>
            </div>

            {/* To Date */}
            <div className='w-1/4 px-4'>
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="to">To</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="to"
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  max={moment().format('yyyy-MM-DD')}
                />
              </div>
            </div>

            {/* Search Button */}
            <div className='w-1/4 px-4 self-center'>
              <button
                className="bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                type="button"
                onClick={submit}
              >
                Search
              </button>
            </div>
            <AccountPrintPage totalAmount={totalAmount} lotteryReport={lotteryReport} fromDate={fromDate} toDate={toDate} />
          </div>

          {/* Toggle Buttons */}
          <div className="flex flex-shrink-0 bg-dark overflow-hidden w-max">
            <button
              className={`px-4 py-2 text-sm font-medium transition-all duration-300 ${reportType === "all"
                ? "bg-[#e54859] text-white"
                : "bg-transparent text-gray-500 hover:bg-gray-200"
                }`}
              onClick={() => setReportType("all")}
            >
              All
            </button>
            <button
              className={`px-4 py-2 text-sm font-medium transition-all duration-300 ${reportType === "1D"
                ? "bg-[#e54859] text-white"
                : "bg-transparent text-gray-500 hover:bg-gray-200"
                }`}
              onClick={() => setReportType("two_chance")}
            >
              2D
            </button>
            <button
              className={`px-4 py-2 text-sm font-medium transition-all duration-300 ${reportType === "2d"
                ? "bg-[#e54859] text-white"
                : "bg-transparent text-gray-500 hover:bg-gray-200"
                }`}
              onClick={() => setReportType("2d")}
            >
              4D
            </button>
            <button
              className={`px-4 py-2 text-sm font-medium transition-all duration-300 ${reportType === "3d"
                ? "bg-[#e54859] text-white"
                : "bg-transparent text-gray-500 hover:bg-gray-200"
                }`}
              onClick={() => setReportType("3d")}
            >
              3D
            </button>
            <button
              className={`px-4 py-2 text-sm font-medium transition-all duration-300 ${reportType === "Titli"
                ? "bg-[#e54859] text-white"
                : "bg-transparent text-gray-500 hover:bg-gray-200"
                }`}
              onClick={() => setReportType("lucky_sorat")}
            >
              Titli
            </button>
          </div>
        </div>

        {/* Report Table */}
        <div className="report_table_div mt-4">
          <table className={`table report_table w-full ${reportType !== "all" ? "strip" : ""}`}>
            <thead className="bg-gray-100">
              <tr>
                <th>Date</th>
                {reportType === "all" && <th>Type</th>}
                <th>Play Points</th>
                <th>Win Points</th>
                <th>End Points</th>
                {userDetail?.is_user !== true && (
                  <th>Commission</th>
                )}
                {userDetail?.is_user !== true && (<th>Final Amount</th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {(() => {
                const records = buildRecords()
                if (!records.length) {
                  return (
                    <tr>
                      <td colSpan={reportType === "all" ? 7 : 6}> No Data Found </td>
                    </tr>
                  )
                }

                // Calculate totals
                let totals = {
                  play_amount: 0,
                  win_amount: 0,
                  end_amount: 0,
                  commission_amount: 0,
                  final_amount: 0
                }

                records.forEach(rec => {
                  totals.play_amount += rec.play_amount
                  totals.win_amount += rec.win_amount
                  totals.end_amount += rec.end_amount
                  totals.commission_amount += rec.commission_amount
                  totals.final_amount += (rec.play_amount - rec.win_amount) - rec.commission_amount
                })

                if (reportType !== "all") {
                  return (
                    <>
                      {records.map((rec, index) => (
                        <tr key={index}>
                          <td>{moment(rec.date, 'DD:MM:YYYY').format('DD/MM/YYYY')}</td>
                          <td>{Math.floor(rec.play_amount)}</td>
                          <td>{Math.floor(rec.win_amount)}</td>
                          <td>{Math.floor(rec.end_amount)}</td>
                          {userDetail?.is_user !== true && (
                            <td>{parseFloat(rec.commission_amount).toFixed(2)}</td>)}
                          {userDetail?.is_user !== true && (<td>{Math.floor((rec.play_amount - rec.win_amount) - rec.commission_amount)}</td>)}
                        </tr>
                      ))}
                      {/* Total Row */}
                      <tr className="font-bold bg-gray-400" style={{ background: "#9ca3af" }}>
                        <td>Total</td>
                        <td>{Math.floor(totals.play_amount)}</td>
                        <td>{Math.floor(totals.win_amount)}</td>
                        <td>{Math.floor(totals.end_amount)}</td>
                        {userDetail?.is_user !== true && (
                          <td>{parseFloat(totals.commission_amount).toFixed(2)}</td>
                        )}
                        {userDetail?.is_user !== true && (<td>{Math.floor(totals.final_amount)}</td>)}
                      </tr>
                    </>
                  )
                }

                // Group by date for "All"
                let grouped = {}
                records.forEach(rec => {
                  let d = moment(rec.date, "DD:MM:YYYY").format("DD/MM/YYYY")
                  if (!grouped[d]) grouped[d] = []
                  grouped[d].push(rec)
                })

                return (
                  <>
                    {Object.entries(grouped).map(([date, recs], groupIndex) =>
                      recs.map((rec, rowIndex) => (
                        <tr
                          key={`${groupIndex}-${rowIndex}`}
                          style={{ background: groupIndex % 2 === 0 ? "#e7e7e7" : "#f6f6f6" }}
                        >
                          {rowIndex === 0 && (
                            <td rowSpan={recs.length} className="align-middle font-medium">
                              {date}
                            </td>
                          )}
                          <td>{rec.type}</td>
                          <td>{Math.floor(rec.play_amount)}</td>
                          <td>{Math.floor(rec.win_amount)}</td>
                          <td>{Math.floor(rec.end_amount)}</td>

                          {userDetail?.is_user !== true && (
                            <td>{parseFloat(rec.commission_amount).toFixed(2)}</td>)}
                          {userDetail?.is_user !== true && (
                            <td>{Math.floor((rec.play_amount - rec.win_amount) - rec.commission_amount)}</td>)}
                        </tr>
                      ))
                    )}
                    {/* Total Row */}
                    <tr className="font-bold bg-gray-400">
                      <td colSpan={reportType === "all" ? 2 : 1}>Total</td>
                      <td>{Math.floor(totals.play_amount)}</td>
                      <td>{Math.floor(totals.win_amount)}</td>
                      <td>{Math.floor(totals.end_amount)}</td>
                      {userDetail?.is_user !== true && (
                      <td>{parseFloat(totals.commission_amount).toFixed(2)}</td>)}
                      {userDetail?.is_user !== true && (<td>{Math.floor(totals.final_amount)}</td>)}
                    </tr>
                  </>
                )
              })()}
            </tbody>
          </table>
        </div>
      </div>
    </ModalContainer>
  )
}

export default AccountPopup3d
